var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInvoiceDue = function SvgInvoiceDue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    stroke: "var(--svg-stroke-color, inherit)",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.333,
    d: "M13.834 5.333v-4H3.167v13.333l2-1.333.667.667M5.833 4h5.333M5.833 6.667h2M5.833 9.333h.333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.333,
    d: "M15.703 13.62a1.19 1.19 0 0 1-.04 1.153 1.2 1.2 0 0 1-1.004.56H9.01a1.2 1.2 0 0 1-1.004-.56 1.19 1.19 0 0 1-.047-1.153l2.807-5.634a1.185 1.185 0 0 1 1.679-.477c.187.116.338.28.437.477zM11.833 13.333h.007M11.833 10v1.333"
  })));
};
export default SvgInvoiceDue;